import { apiClient } from "helpers/api_helper";

export const getAllCityData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/City/GetAllCity`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const getCityListByStateId = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/City/GetCitySelectListByStateId?stateId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};
